

    function getMeetingPriorityMap() {
        return {
            OCVC: 1,
            WGVC: 2,
            EXVC: 3
        };
    }

    export default {
        getMeetingPriorityMap: getMeetingPriorityMap
    };
